addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-barcodes]').forEach(collection => {
        const rows = collection.querySelector('[data-product-barcodes-rows]');
        const add = collection.querySelector('[data-product-barcodes-add]');
        const empty = collection.querySelector('[data-product-barcodes-empty]');
        if (!rows || !add || !collection.dataset.prototype) return;

        const existingIndexes = Array.from(rows.querySelectorAll('[data-product-barcode-row]'))
            .map(row => Number(row.dataset.index))
            .filter(Number.isFinite);
        let nextIndex = existingIndexes.length ? Math.max(...existingIndexes) + 1 : 0;
        const originalBarcodes = new WeakMap();
        const initiallyDisabled = new WeakMap();
        const primaryInputs = () => rows.querySelectorAll('input[type="checkbox"][name$="[primaryBarcode]"]');
        const updateEmpty = () => empty && empty.classList.toggle('d-none', !!rows.querySelector('[data-product-barcode-row]'));
        const selectFirstPrimary = () => {
            if (Array.from(primaryInputs()).some(input => input.checked)) return;
            const first = Array.from(primaryInputs()).find(input => !input.disabled);
            if (first) first.checked = true;
        };
        const syncStatus = row => {
            const status = row.querySelector('select[name$="[status]"]');
            const primary = row.querySelector('input[type="checkbox"][name$="[primaryBarcode]"]');
            if (!status || !primary) return;
            const forbidden = status.value === 'forbidden';
            primary.disabled = initiallyDisabled.get(primary) || forbidden;
            if (forbidden) primary.checked = false;
            selectFirstPrimary();
        };

        rows.querySelectorAll('[data-product-barcode-row]').forEach(row => {
            const barcode = row.querySelector('input[name$="[barcode]"]');
            const primary = row.querySelector('input[type="checkbox"][name$="[primaryBarcode]"]');
            if (barcode) originalBarcodes.set(row, barcode.value);
            if (primary) initiallyDisabled.set(primary, primary.disabled);
            syncStatus(row);
        });

        add.addEventListener('click', () => {
            const holder = document.createElement('div');
            holder.innerHTML = collection.dataset.prototype.replace(/__name__/g, String(nextIndex++));
            const row = holder.querySelector('[data-product-barcode-row]');
            if (!row) return;
            rows.append(row);
            selectFirstPrimary();
            updateEmpty();
            row.querySelector('input[name$="[barcode]"]')?.focus();
        });

        rows.addEventListener('click', event => {
            const remove = event.target.closest('[data-product-barcode-remove]');
            if (!remove || !rows.contains(remove)) return;
            remove.closest('[data-product-barcode-row]').remove();
            selectFirstPrimary();
            updateEmpty();
        });

        rows.addEventListener('change', event => {
            const selected = event.target;
            if (selected.matches('select[name$="[status]"]')) {
                syncStatus(selected.closest('[data-product-barcode-row]'));
                return;
            }
            if (!selected.matches('input[type="checkbox"][name$="[primaryBarcode]"]') || !selected.checked) return;
            if (selected.closest('[data-product-barcode-row]').querySelector('select[name$="[status]"]')?.value === 'forbidden') {
                selected.checked = false;
                return;
            }
            const fixed = Array.from(primaryInputs()).find(input => input !== selected && input.disabled && input.checked);
            if (fixed) {
                selected.checked = false;
                return;
            }
            primaryInputs().forEach(input => { if (input !== selected) input.checked = false; });
        });

        rows.addEventListener('input', event => {
            const barcode = event.target;
            if (!barcode.matches('input[name$="[barcode]"]')) return;
            const row = barcode.closest('[data-product-barcode-row]');
            if (!originalBarcodes.has(row) || barcode.value.trim() === originalBarcodes.get(row).trim()) return;
            const status = row.querySelector('select[name$="[status]"]');
            if (!status || status.value === 'unverified') return;
            status.value = 'unverified';
            syncStatus(row);
        });
    });
});
